import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { AdminAttemptToLogin } from "./Components/Services";

const AdminLogin = () => {
  const initialState = {
    loading: false,
    data: {
      mobile: null,
      password: null,
    },
  };

  const [state, setState] = useState(initialState);

  const AdminLoginHandler = (mobile, password) => {
    setState({ ...state, loading: true });
    AdminAttemptToLogin(mobile, password).then(result => {
      setState({
        ...state,
        loading: false,
        data: { ...state.data, result: result },
      });
      if (typeof result === "object") {
        localStorage.setItem("user", JSON.stringify(result));
        localStorage.setItem("user_type", JSON.stringify("admin"));
        window.location.replace("/Admin/Dashboard");
      }
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ورود به سایت</title>
      </Helmet>
      <div
        className="main-login d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="container-fluid px-3 px-md-5">
          <div className="row justify-content-center">
            <div
              className="col-lg-4 col-md-8 col-sm-7 col-10  rounded-11 login part-padding"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.24) 0px 0px 5px",
              }}
            >
              <div className="center">
                <div className="top mb-5 d-flex flex-column align-items-center justify-content-center">
                  <Link to={"/"}>
                    <img
                      className="img"
                      style={{ width: "150px" }}
                      src={window.origin + "/WebSide/assets/images/logo.png"}
                      alt="nikotan | نیکوتن"
                    />
                  </Link>

                  <img
                    style={{
                      width: "100%",
                    }}
                    className="mt-1"
                    src={window.origin + "/WebSide/assets/images/sam.png"}
                  />
                </div>
                <div className="form-group login-form-group mx-auto">
                  <div className="inputt-group">
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      شماره موبایل خود را وارد نمایید
                    </p>
                    <input
                      className="form-control mb-3"
                      type="text"
                      value={state.data.mobile}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, mobile: e.target.value },
                        });
                      }}
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          AdminLoginHandler(
                            state.data.mobile,
                            state.data.password
                          );
                        }
                      }}
                      placeholder="شماره موبایل"
                      style={{ borderRadius: "10px" }}
                    />
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      کلمه عبور خود را وارد نمایید
                    </p>
                    <input
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          AdminLoginHandler(
                            state.data.mobile,
                            state.data.password
                          );
                        }
                      }}
                      className="form-control mb-3"
                      type="password"
                      value={state.data.password}
                      onChange={e => {
                        setState({
                          ...state,
                          data: { ...state.data, password: e.target.value },
                        });
                      }}
                      placeholder="کلمه عبور"
                      style={{ borderRadius: "10px" }}
                    />
                  </div>
                </div>
                <button
                  onClick={() =>
                    AdminLoginHandler(state.data.mobile, state.data.password)
                  }
                  className={`btn btn-red-v2 w-100 h6 mb-3 text-white
                                ${
                                  state.loading ? "disabled" : null
                                }                                    
                                `}
                  style={{ borderRadius: "10px" }}
                >
                  {state.loading ? "در حال پردازش..." : "ورود"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AdminLogin;
